import { module } from 'modujs';
import { gsap } from "gsap";
import { ENV } from "../config";

export default class extends module {
    constructor(m) {
        super(m);

        // this.bigTitle = this.el.querySelector('.o-header_title');
        // this.bigTitleLines = this.bigTitle.querySelectorAll('div');
        // this.bigTitleWords = this.bigTitle.querySelectorAll('span');

        // this.surtitle = this.el.querySelector('.o-header_content .c-text-num');
        // this.surtitleNum = this.surtitle.querySelector('.c-text-num_value');
        // this.surtitleContent = this.surtitle.querySelector('.c-text-num_content');

        // this.title = this.el.querySelector('.o-header_content .c-heading.-h3');

        this.button = this.el.querySelector('.c-circle-button');
    }

    init() {
        this.tl = gsap.timeline({
            paused: true,
            // onComplete: () => {
            //     this.call('firstScroll', 'Scroll');
            // }
        });

        // if (ENV.IS_MD && ENV.IS_TOUCH) {
        //     this.tl.fromTo(
        //         this.bigTitle,
        //         { y: '5svh', opacity: 0 },
        //         { y: '0', opacity: 1, duration: 0.8, ease: 'power4.out' }
        //     );
        // } else {
        //     this.tl.fromTo(
        //         this.bigTitle,
        //         { scaleY: 4, y: '40svh', transformOrigin: 'top center' },
        //         { scaleY: 1, y: '0', transformOrigin: 'top center', duration: 1.2, ease: 'elastic.out(1,0.7)' }
        //     );
        // }

        if (ENV.IS_MD) {
            // this.tl.call(() => { this.title.classList.add('is-inview'); }, null, 0);
            // this.tl.call(() => { this.surtitleNum.classList.add('is-inview'); }, null, 0.3);
            // this.tl.call(() => { this.surtitleContent.classList.add('is-inview'); }, null, 0.4);

            this.tl.fromTo(
                this.button,
                { scale: 0 },
                { scale: 1, duration: 1.2, ease: 'elastic.out(1,0.4)' },
                0
            );
        } else {
            // this.tl.call(() => { this.surtitleNum.classList.add('is-inview'); }, null, 0);
            // this.tl.call(() => { this.surtitleContent.classList.add('is-inview'); }, null, 0.1);
            // this.tl.call(() => { this.title.classList.add('is-inview'); }, null, 0.3);

            this.tl.fromTo(
                this.button,
                { scale: 0 },
                { scale: 1, duration: 1.2, ease: 'elastic.out(1,0.4)' },
                0
            );
        }
    }

    play() {
        this.tl.play();
    }

    onScroll(args) {
        // if (ENV.IS_MD && ENV.IS_TOUCH) {
        //     gsap.to(this.bigTitle, { scaleX: 1 + (args.velocity * 0.008), duration: 1, ease: 'power4.out' });
        // } else {
        //     gsap.to(this.bigTitle, { scaleY: 1 + (args.velocity * 0.005), duration: 1, ease: 'power4.out' });
        // }
    }
}
